import { atom } from 'jotai';
import { componentsAtom } from './componentsAtom';

/**
 * startDateAtom
 * Derived atom exposing the load profile startDate stored at:
 * componentsAtom.load.componentAttributes.loadParameters.profileDetail.startDate
 *
 * Read:   const [startDate] = useAtom(startDateAtom);
 * Write:  const [, setStartDate] = useAtom(startDateAtom); setStartDate(new Date());
 * Setter replaces only the nested startDate while preserving other keys.
 */
export const startDateAtom = atom(
  (get) => get(componentsAtom).load?.componentAttributes?.loadParameters?.profileDetail?.startDate ?? null,
  (get, set, newDate) => {
    const prev = get(componentsAtom);
    // Defensive cloning preserving full structure
    const updated = {
      ...prev,
      load: {
        ...prev.load,
        componentAttributes: {
          ...prev.load.componentAttributes,
          loadParameters: {
            ...prev.load.componentAttributes.loadParameters,
            profileDetail: {
              ...prev.load.componentAttributes.loadParameters.profileDetail,
              startDate: newDate,
            },
          },
        },
      },
    };
    set(componentsAtom, updated);
  }
);

export default startDateAtom;
